import { useEditEntityDrawer, UseEditEntityDrawerReturnType } from '../UseEditEntityDrawer';
import { PassOut } from '../../../api';
import { CalendarSlot } from '../SlotActionsMenu/CalendarSlot';

export type EditOrderDrawerState = {
  order?: any;
  orderPageId?: string;
  parentId?: string;
  parent?: any;
  voucherToRedeem?: any;
  createVoucher?: any;
  waitingListItem?: any;
  voucherToEdit?: any;
  cloneOrder?: any;
  passToRedeem?: PassOut;
  // Opened from "finalise bill": expand and scroll to the extra items section.
  focusExtraItems?: boolean;
  // With focusExtraItems: also open the catalog picker in the extra items section.
  openCatalog?: boolean;
  // With focusExtraItems: also open the settle dialog in the extra items section.
  openCheckout?: boolean;
  // Opened from an order's comment marker: expand the panel holding the comment and scroll to it.
  focusComment?: boolean;
  // Opened from an agenda card's "move table": expand the management panel and scroll to the resource picker.
  focusResources?: boolean;
  // Opened from an empty calendar slot: a new order starts on the slot's date and time.
  slot?: CalendarSlot;
  isOpen: boolean;
};

export const useEditOrderDrawer = (): UseEditEntityDrawerReturnType<EditOrderDrawerState> => {
  return useEditEntityDrawer<EditOrderDrawerState>({ isOpen: false });
};
